var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "region_list" },
    [
      _c(
        "div",
        { staticClass: "btn-group choice_region" },
        _vm._l(_vm.regions, function (item) {
          return _c(
            "button",
            {
              staticClass: "btn btn-outline-primary waves-effect waves-themed",
              class: _vm.calss_region(item),
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.set_active(item)
                },
              },
            },
            [_vm._v("\n            " + _vm._s(item.name) + "\n        ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "panel-tag mt-2 mb-2" }, [
        _c(
          "div",
          {
            staticClass: "btn-group btn-group-sm btn-group-toggle",
            attrs: { id: "js_change_tab_direction", "data-toggle": "buttons" },
          },
          [
            _c(
              "label",
              {
                staticClass:
                  "btn btn-primary active waves-effect waves-themed cursor-pointer",
                attrs: {
                  "data-action": "",
                  "data-class": "n",
                  "data-target": "",
                },
                on: {
                  click: function ($event) {
                    return _vm.check_uncheck(true)
                  },
                },
              },
              [
                _c("input", {
                  attrs: {
                    type: "radio",
                    name: "radioNameTabDirection",
                    checked: "",
                    value: "nav nav-tabs",
                  },
                }),
                _vm._v(" Обрати Всі\n            "),
              ]
            ),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass:
                  "btn btn-success waves-effect waves-themed cursor-pointer",
                attrs: {
                  "data-action": "",
                  "data-class": "",
                  "data-target": "",
                },
                on: {
                  click: function ($event) {
                    return _vm.check_uncheck(false)
                  },
                },
              },
              [
                _c("input", {
                  attrs: {
                    type: "radio",
                    name: "radioNameTabDirection",
                    value: "nav nav-tabs justify-content-end",
                  },
                }),
                _vm._v(" Зняти виділення\n            "),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "badge badge-primary float-right" }, [
          _vm._v("В списку " + _vm._s(_vm.userlist.length) + " користувачів "),
        ]),
      ]),
      _vm._v(" "),
      _vm.is_load
        ? _c("div", { staticClass: "load_user pt-3" }, [
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("b-spinner", {
                  attrs: { variant: "warning", label: "Text Centered" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("user_list", { attrs: { users: _vm.users } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }